export default {
  title: 'Ristorante con Terrazza a Valdobbiadene | Osteria alla Terrazza',
  titleMenu:
    'Menù stagionale di cucina veneta a Valdobbiadene | Osteria alla Terrazza',
  titleWine: 'Carta vini e Prosecco DOCG a Valdobbiadene | Osteria alla Terrazza',
  description:
    'Osteria panoramica a Valdobbiadene sulla Strada del Prosecco: cucina veneta, calici DOCG, aperitivo e vista sulle colline UNESCO.',
  descriptionWine:
    'Selezione di Valdobbiadene Prosecco Superiore DOCG, Cartizze e vini del territorio da gustare in terrazza con vista vigneti.',
  descriptionMenu:
    'Scopri il menù stagionale con piatti della tradizione veneta, ingredienti locali e specialità da gustare sulle colline del Prosecco.',
}
